import React, {useMemo, useState} from 'react';
import {useHistory} from "react-router";

import {JobList} from "components/JobList";
import {BackendJob, HygienistBackendJob} from "components/EditJob";
import {SectionTabs} from "components/SectionTabs";

import {JobBoardTab} from "./types";
import {getJobsByTab, useClearJobPost} from "./utils";

import {
    Container,
    EventOutlinedIconStyled,
    NoJobsMessage,
    StyledButton,
    Title,
    TitleContainer,
    TokenIcon,
    TokensButton
} from './JobBoard.styles';
import clsx from 'clsx';
interface JobBoardProps {
    jobs: BackendJob[];
    dentistUserEmail: string;
    tokensCount: number;
    onTokensClick: () => void;
}

const JobBoard = ({ dentistUserEmail, jobs, tokensCount, onTokensClick }: JobBoardProps) => {
    const history = useHistory();
    const [activeTab, setActiveTab] = useState<JobBoardTab>(JobBoardTab.activeJobs);
    const clearJobPost = useClearJobPost(dentistUserEmail);

    const { active, inactive } = useMemo(() => getJobsByTab(jobs), [jobs]);

    const onJobClick = (job: BackendJob | HygienistBackendJob) => {
        history.push({
            pathname: 'jobBoardDetails',
            state: {
                job,
            },
        })
    }

    const onJobAdd = () => {
        clearJobPost();

        history.push({
            pathname: "editJobFirstStep",
            state: { mode: "post" }
        })
    }

    const jobsToDisplay = activeTab === JobBoardTab.activeJobs ? active : inactive;

    const tabs = [
        {label: 'Active', onClick: () => setActiveTab(JobBoardTab.activeJobs), isActive: activeTab === JobBoardTab.activeJobs},
        {label: 'Inactive', onClick: () => setActiveTab(JobBoardTab.inactiveJobs), isActive: activeTab === JobBoardTab.inactiveJobs},
    ]

    return (
        <Container>
            <TitleContainer>
                <Title>Your Job Posts</Title>
            </TitleContainer>
            <SectionTabs tabs={tabs} tokensCount={tokensCount} onTokensClick={onTokensClick}/>
            {jobsToDisplay && jobsToDisplay.length ? (
                <JobList
                    jobs={jobsToDisplay}
                    onJobClick={onJobClick}
                    isActive={activeTab === JobBoardTab.activeJobs}
                />
            ) : (
                <NoJobsMessage>
                    You have no {activeTab === JobBoardTab.activeJobs ? 'active' : 'inactive'} jobs posts yet.
                </NoJobsMessage>
            )}
            <StyledButton
                variant="contained"
                onClick={onJobAdd}
                color="primary"
                size="large"
                id="add-new-job-button"
                className={clsx("bigButtonInNewStyle", "no-fastclick")}
            >
                <span>Post a Job</span>
                <EventOutlinedIconStyled />
            </StyledButton>
        </Container>
    )
}

export default JobBoard;
